import { render, staticRenderFns } from "./TerrorZoneQueryTable.vue?vue&type=template&id=32ac0070&scoped=true"
import script from "./TerrorZoneQueryTable.vue?vue&type=script&lang=js"
export * from "./TerrorZoneQueryTable.vue?vue&type=script&lang=js"
import style0 from "./TerrorZoneQueryTable.vue?vue&type=style&index=0&id=32ac0070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ac0070",
  null
  
)

export default component.exports